/**
 * Toast position
 */
export default {
  leftTop   : 'leftTop',
  leftCenter: 'leftCenter',
  leftBottom: 'leftBottom',

  rightTop   : 'rightTop',
  rightCenter: 'rightCenter',
  rightBottom: 'rightBottom',

  centerTop   : 'centerTop',
  centerCenter: 'centerCenter',
  centerBottom: 'centerBottom'
}
